import { MaintenanceMode } from 'hiber-grpc/src/customer_compiled/status';
import { defineStore } from 'pinia';

export const useMaintenanceStore = defineStore('maintenance', {
  state: () => ({
    maintenanceMode: MaintenanceMode.NONE,
  }),
  actions: {
    setMaintenanceMode(mode: MaintenanceMode) {
      this.maintenanceMode = mode;
    },
  },
  getters: {
    isInMaintenance(state) {
      return state.maintenanceMode !== MaintenanceMode.NONE && state.maintenanceMode !== MaintenanceMode.UNRECOGNIZED;
    },
  },
});
